import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboVerracosPresentesActivos`, method: 'GET', body: null, token: token})
}